import { DataMergerLogicalAnd } from './../mergers/data-merger-logical-and';
import { DataMergerLogicalOr } from './../mergers/data-merger-logical-or';

import { DataLocationFilter } from './../filters/data-location-filter';
import { DataFilter } from './../filters/data-filter';

import { DataSourceLoader } from './../../data-sources/loader/data-source-loader';

export class DataFiltersLoader {
    public allFiltersMerger: DataMergerLogicalAnd;
    public locationFiltersMerger: DataMergerLogicalOr;
    public dataFilter: DataFilter;
    public searchFilter: DataFilter;

    constructor(private dataSourceLoader: DataSourceLoader) {
        this.allFiltersMerger = new DataMergerLogicalAnd(dataSourceLoader.employeesDataSource, [], this);
        this.locationFiltersMerger = new DataMergerLogicalOr(dataSourceLoader.employeesDataSource, [], this);
        this.dataFilter = new DataFilter(dataSourceLoader.employeesDataSource);
        this.searchFilter = new DataFilter(dataSourceLoader.employeesDataSource);

        this.allFiltersMerger.addFilter(this.locationFiltersMerger);
        this.allFiltersMerger.addFilter(this.dataFilter);
        this.allFiltersMerger.addFilter(this.searchFilter);
    }

    // The public methods are for filters that can be added by a command from the UI.

    public createLocationFilter() {
        let dataLocationFilter = new DataLocationFilter(this.dataSourceLoader.employeesDataSource);
        this.locationFiltersMerger.addFilter(dataLocationFilter);
        return dataLocationFilter;
    }
}
